import LoginId               from "../../../domain/authentication/LoginId";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import Staff                 from "../../../domain/staff/Staff";
import StaffId               from "../../../domain/staff/StaffId";
import StaffMemo             from "../../../domain/staff/StaffMemo";
import StaffRepository       from "../../../domain/staff/StaffRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import StaffDataSource       from "../../../infrastructure/datasource/staff/StaffDataSource";

class GetStaffOnAccount {
  private readonly repository: StaffRepository = new StaffDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(callback: (staff: Staff) => void) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.findByAccount();
      callback(new Staff(
        new StaffId(response.data.id),
        new Name(
          new LastName(response.data.last_name),
          new FirstName(response.data.first_name),
          new LastNameKana(response.data.last_name_kana),
          new FirstNameKana(response.data.first_name_kana)
        ),
        response.data.gender,
        new StaffMemo(response.data.memo),
        LoginId.of(response.data.login_id),
      ));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetStaffOnAccount;
